// extracted by mini-css-extract-plugin
export default {"title":"MyLoans_title__bLFWG"};